var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFooterFixedBlog = function SvgIconFooterFixedBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m10.776 11.224-1.697.602a.317.317 0 0 1-.405-.405l.602-1.697a.063.063 0 0 1 .016-.025l4.49-4.49a.568.568 0 0 1 .802 0l.707.707a.568.568 0 0 1 0 .802l-4.49 4.49a.063.063 0 0 1-.025.016Zm1.724-.3V12.5A1.498 1.498 0 0 1 11 14H3a1.498 1.498 0 0 1-1.5-1.5v-7h10.576L8.584 8.992a1.065 1.065 0 0 0-.25.398l-.603 1.696a1.318 1.318 0 0 0 1.683 1.682l1.696-.602c.15-.053 1.39-1.242 1.39-1.242ZM4 11.5h1.585a.5.5 0 0 0 0-1H4a.5.5 0 0 0 0 1Zm0-2h2.585a.5.5 0 0 0 0-1H4a.5.5 0 0 0 0 1Zm0-2h4.585a.5.5 0 0 0 0-1H4a.5.5 0 0 0 0 1Zm-2.5-3v-1A1.498 1.498 0 0 1 3 2h8a1.498 1.498 0 0 1 1.5 1.5v1h-11Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconFooterFixedBlog;